import { HTTP_CP_CreateHelpCase_Request } from '@api-new/caseservice';
import { AddSmartSearchDialogFormRawValues } from '@platform/smart-search/utils/formUtils';

export const createSmartSearchHelpCaseFormFormToHTTPRequest = (
  formData: AddSmartSearchDialogFormRawValues,
  clientUserData: { firstName: string; lastName: string },
): HTTP_CP_CreateHelpCase_Request => ({
  propertyId: formData.propertySelection.propertyMortgageSelectItem?.propertyId,
  helpCaseType: formData.remortgageSpeakToAnExpert.type,
  message: formData.remortgageSpeakToAnExpert.helpCaseName,
  clientUserDetails: {
    phoneNumber: formData.remortgageSpeakToAnExpert.phoneNumber,
    firstName: clientUserData.firstName,
    lastName: clientUserData.lastName,
  },
});
